import React from "react";
import classes from "./FeedbackPopupOld.module.css"
import { useSelector } from "react-redux";

const FeedbackPopup = ({ close, type, correctAnsText }) => {

    const { texts } = useSelector(state => state.translate);

    const types = {
        correct: {
            content: <div>{texts.correctAnswer}</div>,
        },
        inCorrect: {
            content: <div>{texts.wrongAnswer}</div>,
        },
        maxRetries: {
            content: correctAnsText,
        },
        accepted: {
            content: <div>{texts.answerRecived}</div>,
        }
    }
    return <>
        <div className={`${classes.Popup} ${classes[type]}`}>
            {type === 'maxRetries' && <div className={classes.PopupHeader}>
                <div className={classes.PopupHeaderX}>X</div>
                <div className={classes.PopupHeaderText}>{texts.correctAnswerIs}</div>
            </div>}
            <div className={`${classes.PopupContent} ${type === 'maxRetries' && classes[type]}`}>
                {types && types[type]?.content}
            </div>
        </div>
    </>
}
export default FeedbackPopup;